import { j as o, I as b, S as w } from "./Spinner-yxPaS-Vf.js";
import { useState as j } from "react";
import { styled as r } from "styled-components";
import { f, e as g } from "./index-tc-On6zr.js";
import { j as u, c as l, o as $, T as m, d as y, e as v } from "./style-ImpGK6sv.js";
import { u as T } from "./useTransitionState-9D4Z4_FK.js";
import { u as A } from "./useResizeObserver-ghdBe7Hs.js";
import { C } from "./icon-chevron-KKUvu9gg.js";
const E = r.ul`
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  overflow: hidden;
  list-style: none;
`, k = r.li.attrs({
  $justifyContent: "space-between",
  $flexWrap: "wrap"
})`
  ${f}
  ${u("border-color")};

  border-bottom: 1px solid ${l.greyAlpha10};

  &:first-child {
    border-top: 1px solid ${l.greyAlpha10};
  }
`, S = r.h3`
  position: relative;
  margin: 0;
  padding: 0;
`, I = r.button.attrs({
  $alignItems: "center",
  $flexWrap: "nowrap",
  $justifyContent: "space-between"
})`
  ${f}
  ${$(m.action)}

  border: 0;
  background-color: ${l.white};
  cursor: pointer;
  padding: ${g.spacer3} 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    color: ${l.greyAlpha40};
  }

  /* Show "outline" when focused by keyboard only */
  [data-whatintent='keyboard'] &:focus-within {
    outline: 1px solid;
    ${y("outline-color", "dominant")};
    outline-offset: -1px;
  }
`, O = r.div`
  ${u("height", v.shorter)};

  position: relative;
  height: ${({ $height: n, $inTransition: t }) => t ? `${n}px` : "auto"};
  overflow: hidden;
`, z = r.div`
  ${$(m.body)}

  padding: ${g.spacer4} 0;
`, P = r.fieldset`
  border: 0;
  padding: 0;
  margin: 0;
  width: 100%;
`, R = r.legend`
  width: 100%;
`, W = ({
  title: n,
  isOpen: t,
  onClick: p,
  disabled: a,
  children: s,
  isLoading: h
}) => {
  const [d, e, i] = T(t, ["height"]), [{ height: c }, x] = A();
  return /* @__PURE__ */ o.jsx(k, { children: /* @__PURE__ */ o.jsxs(P, { children: [
    /* @__PURE__ */ o.jsx(R, { children: /* @__PURE__ */ o.jsx(S, { children: /* @__PURE__ */ o.jsxs(I, { onClick: p, disabled: a, "aria-expanded": e, children: [
      /* @__PURE__ */ o.jsx("span", { children: n }),
      /* @__PURE__ */ o.jsx(b, { icon: C, size: "xs", rotation: e ? 90 : 270 })
    ] }) }) }),
    (e || d) && !a && /* @__PURE__ */ o.jsxs(
      O,
      {
        $inTransition: d,
        $height: e && c ? c : 0,
        onTransitionEnd: i,
        children: [
          /* @__PURE__ */ o.jsx(w, { hasOverlay: !0, visible: h }),
          /* @__PURE__ */ o.jsx(z, { ref: x, children: s })
        ]
      }
    )
  ] }) });
}, q = (n) => Object.fromEntries(n.map((t) => [t.id, !!t.expanded])), M = ({ items: n, expandMultiple: t, isLoading: p, className: a }) => {
  const [s, h] = j(n ? q(n) : {}), d = (e) => {
    const i = t ? s : {};
    i[e] = !s[e], h({ ...i });
  };
  return /* @__PURE__ */ o.jsx(E, { className: a, "data-qa": "accordion", children: n && n.map(({ id: e, children: i, title: c, disabled: x }) => /* @__PURE__ */ o.jsx(
    W,
    {
      title: c,
      isOpen: s[e] || !1,
      disabled: x,
      onClick: () => d(e),
      isLoading: p,
      children: i
    },
    e
  )) });
};
export {
  M as A
};
